<template>
<div class="chapter">
<div class="inner_page">
<p class="sp" id="ded"> </p>
<p class="Dedication-ded"><span class="ePub-I">For my mom and dad and my wonderful supportive children, Kaya and Nora, whose own amazing stories are unfolding</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?9a74115e